import {Component, input} from "@angular/core";
import {Translations} from "@translations";

@Component({
	selector: "sim-clinical-vignette-view",
	templateUrl: "./clinical-vignette-view.component.html",
	styleUrl: "./clinical-vignette-view.component.scss",
	standalone: false,
})
export class ClinicalVignetteViewComponent {
	protected readonly T = Translations;

	public clinicalVignetteText = input.required<string>();
	public hideHeader = input<boolean>(false);
}
